var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7L22 7",
    stroke: "#7A5AF8",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 1V4",
    stroke: "#7A5AF8",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 1V4",
    stroke: "#7A5AF8",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 2H7V3H16V2ZM20 3H21C21.5523 3 22 3.44772 22 4V23C22 23.5523 21.5523 24 21 24H2C1.44772 24 1 23.5523 1 23V4C1 3.44772 1.44772 3 2 3H3V2H2C0.895431 2 0 2.89543 0 4V23C0 24.1046 0.89543 25 2 25H21C22.1046 25 23 24.1046 23 23V4C23 2.89543 22.1046 2 21 2H20V3Z",
    fill: "#7A5AF8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87542 20.078C8.21675 20.078 7.59275 19.974 7.00342 19.766C6.42275 19.5493 5.95475 19.2633 5.59942 18.908L6.05442 18.167C6.34909 18.4703 6.74342 18.7217 7.23742 18.921C7.74009 19.1203 8.28609 19.22 8.87542 19.22C9.62942 19.22 10.2058 19.0553 10.6044 18.726C11.0118 18.3967 11.2154 17.9547 11.2154 17.4C11.2154 16.8453 11.0161 16.4033 10.6174 16.074C10.2274 15.7447 9.60776 15.58 8.75842 15.58H8.10842V14.891L10.9164 11.368L11.0464 11.732H5.97642V10.9H11.8264V11.563L9.01842 15.086L8.56342 14.787H8.91442C10.0064 14.787 10.8211 15.0297 11.3584 15.515C11.9044 16.0003 12.1774 16.6243 12.1774 17.387C12.1774 17.8983 12.0561 18.3577 11.8134 18.765C11.5708 19.1723 11.2024 19.493 10.7084 19.727C10.2231 19.961 9.61209 20.078 8.87542 20.078ZM15.0823 20V11.29L15.4983 11.732H12.9373V10.9H16.0183V20H15.0823Z",
    fill: "#7A5AF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.c0e3a1880809dd96eb293a349cd0ae52.svg";
export { ForwardRef as ReactComponent };